import React from 'react'
import { Grid } from '@mui/material'
import { isMobile } from '../utils/helpers'

const Col = ({ width, small, big, children, ...props }) => {
  const size = width || (big ? 7 : (small ? 5 : 6))
  return isMobile ? <>{children}</> : <Grid item xs={12} sm={size} {...props}>{children}</Grid>
}

export default Col